export type ContentBlockType = 'heading' | 'subheading' | 'body' | 'check-item' | 'bullet';

export interface ContentBlock {
  type: ContentBlockType;
  text: string;
}

export function parseTabText(text: string): ContentBlock[] {
  return text
    .split('\n')
    .map((line) => line.replace(/\t/g, '').trim())
    .filter((line) => line.length > 0)
    .map((line): ContentBlock => {
      const headingMatch = line.match(/^\*\*(.+)\*\*$/);
      if (headingMatch) {
        return { type: 'heading', text: headingMatch[1].trim() };
      }
      const subheadingMatch = line.match(/^\*(.+)\*$/);
      if (subheadingMatch) {
        return { type: 'subheading', text: subheadingMatch[1].trim() };
      }
      if (line.startsWith('@@')) {
        return { type: 'check-item', text: line.replace(/^@@\s*/, '') };
      }
      if (/^-\s/.test(line)) {
        return { type: 'bullet', text: line.replace(/^-\s*/, '') };
      }
      return { type: 'body', text: line };
    });
}
